/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_NameInputs */

const en_mk_sol_ukm_name = /** @type {(inputs: Mk_Sol_Ukm_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMEs, retail and F&B`)
};

const id_mk_sol_ukm_name = /** @type {(inputs: Mk_Sol_Ukm_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UKM, ritel, dan F&B`)
};

/**
* | output |
* | --- |
* | "SMEs, retail and F&B" |
*
* @param {Mk_Sol_Ukm_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_name = /** @type {((inputs?: Mk_Sol_Ukm_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_name(inputs)
	return en_mk_sol_ukm_name(inputs)
});